import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiServiceService } from 'src/app/services/api-service.service';
import { environment } from 'src/environments/environment.development';

@Component({
  selector: 'app-customer-feedback-page',
  standalone: false,
  templateUrl: './customer-feedback-page.component.html',
  styleUrl: './customer-feedback-page.component.scss'
})
export class CustomerFeedbackPageComponent {
 customerCommentImageUrl = environment.ImageBaseUrl;
productId!: string;
  reviews: any[] = [];
  loading = true;
  product: any;

  constructor(
    private route: ActivatedRoute,
    private reviewsService: ApiServiceService
  ) {}

  ngOnInit(): void {
    this.productId = this.route.snapshot.paramMap.get('id') || '';
    console.log('ProductId received:', this.productId);
    this.fetchReviews();
  }

  fetchReviews(): void {
    this.reviewsService.getReviewsByProduct(this.productId).subscribe({
      next: (res) => {
        this.reviews = res.data;
      
        console.log('thisprodict--->' ,this.product)
        console.log('Reviews:', this.reviews);
        this.loading = false;
      },
      error: (err) => {
        console.error('Error fetching reviews:', err);
        this.loading = false;
      }
    });
  }
}
